var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRank = function SvgIconRank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 52"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_rank_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_rank_svg__b)",
    d: "M10 12.326c0-1.427 1.131-2.584 2.526-2.584h18.948C32.869 9.742 34 10.9 34 12.325v26.81c0 1.218-1.391 1.992-2.534 1.41l-8.237-4.196a2.73 2.73 0 0 0-2.458 0l-8.237 4.196c-1.143.582-2.534-.192-2.534-1.41z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#icon_rank_svg__c)",
    strokeWidth: 2,
    d: "M12.526 10.742h18.948c.822 0 1.526.688 1.526 1.583v26.81c0 .198-.107.385-.324.506a.8.8 0 0 1-.756.012l-8.237-4.195a3.73 3.73 0 0 0-3.366 0l-8.237 4.195a.8.8 0 0 1-.756-.012c-.217-.121-.324-.308-.324-.505v-26.81c0-.896.704-1.584 1.526-1.584Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_rank_svg__b",
    x1: 10,
    x2: 31.748,
    y1: 2.904,
    y2: 27.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C961D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_rank_svg__c",
    x1: 22,
    x2: 22,
    y1: 9.742,
    y2: 40.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F897FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F897FF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon_rank_svg__a",
    width: 44,
    height: 51,
    x: 0,
    y: 0.742,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0745098 0 0 0 0 0.105882 0 0 0 0 0.14902 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1966_139652"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0745098 0 0 0 0 0.105882 0 0 0 0 0.14902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1966_139652",
    result: "effect2_dropShadow_1966_139652"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0745098 0 0 0 0 0.105882 0 0 0 0 0.14902 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_1966_139652",
    result: "effect3_dropShadow_1966_139652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_1966_139652",
    result: "shape"
  })))));
};
export default SvgIconRank;